module.exports = __webpack_public_path__ + "static/img/18.a9f2d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/18.png
// module id = mt/z
// module chunks = 0